let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("3WCRn")]).then(() => parcelRequire('cIjy3'));